import { useContext } from 'react';

import { APP_SETUP_PAGE } from 'src/constants';
import { FlagsContext } from 'src/context/flagsContext';

export const useAppLibraryLabel = () => {
  const { EnableAppSetup } = useContext(FlagsContext);
  return EnableAppSetup ? 'App Library' : APP_SETUP_PAGE.label;
};
